import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

export default class OtherCase {

    static get selector() {
        return '.otherCases';
    }

    constructor(el) {
        this.el = el;
        const swiper = new Swiper('.swiper', {
            modules: [Navigation],

            loop: true,
            slidesPerView: 1,
            spaceBetween: 8,

            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },

            breakpoints: {
                // when window width is >= 320px
                600: {
                  slidesPerView: 2,
                  spaceBetween: 24
                },
                // when window width is >= 480px
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 24
                }
            }
        });

    }


}